<template>
    <AdminLayout>


        <div class="hero-title title-center">Care ID ISSUED </div>

        <div class="view" id="view-care-id">
            <LoadingSpinner :isLoading="isLoading" />
            <div class="page-wrap">

                <ToastManagerVue ref="toastManager" />

                <div class="scene">
                    <!-- GOLD -->
                    <div v-if="cg && cg.verification?.tier === 'gold'">
                        <div class="card gold" ref="card1">
                            <div class="card-bg"></div>
                            <div class="card-texture"></div>
                            <div class="card-glow"></div>
                            <div class="top-bar">
                                <img src="@/assets/white_logo.svg" alt="Succour Logo" style="
            height:28px;
            object-fit:contain;
            display:block;
        " />
                                <div class="care-id-pill">CARE ID</div>
                            </div>
                            <div class="tier-stripe">
                                <div class="tier-text"> {{ cg.verification.tier }} Tier</div>
                            </div>
                            <div class="body">
                                <div class="top-section">
                                    <div class="photo-box">
                                        <img v-if="cg.profile_photo" :src="cg.profile_photo" style="
            width:100%;
            height:100%;
            object-fit:cover;
            display:block;
        " />

                                    </div>
                                    <div class="name-block">
                                        <div class="first-name">{{ cg.fn }}</div>
                                        <div class="last-name">{{ cg.ln }}</div>
                                        <div class="cw-id">{{ cg.care_id }}</div>
                                    </div>
                                </div>
                                <hr class="sep">
                                <div class="score-box">
                                    <div class="score-row"><span class="score-num">{{ cg.verification.trust_score
                                            }}</span><span class="score-denom">/ 835</span></div>
                                    <hr class="score-divider">
                                    <div class="score-label">Trust Score Index</div>
                                </div>
                                <div class="tags">
                                    <div v-for="category in cg.category_links" :key="category.id" class="tag">
                                        {{ category.category_name }}
                                    </div>
                                </div>
                                <div class="footer-row">
                                    <div class="dates-col">
                                        <div>
                                            <div class="field-label">Issue Date</div>
                                            <div class="field-value">{{ formatDate(cg.issued_at) }}</div>
                                        </div>
                                        <div>
                                            <div class="field-label">Expiry Date</div>
                                            <div class="field-value">{{ formatDate(cg.expires_at) }}</div>
                                        </div>
                                        <div class="verify-link"><a :href="verifyLink" class="verify-link">{{ verifyLink
                                                }}</a></div>
                                    </div>

                                    <div :id="`qr-wrap-${qr1}`" class="qr-wrap">
                                        <canvas :ref="qr1"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="share-wrap">

                            <!-- WhatsApp -->
                            <button class="cid-share-btn copy" @click="shareAll('card1')">
                                Share
                            </button>

                            <!-- Copy -->
                            <button class="cid-share-btn copy" @click="copyLink">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <rect x="9" y="9" width="13" height="13" rx="2" />
                                    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                                </svg>

                                {{ copied ? '✓ Copied!' : 'Copy Link' }}
                            </button>

                        </div>
                    </div>

                    <!-- SILVER -->
                    <div v-if="cg && cg.verification?.tier === 'silver'">
                        <div class="card silver" ref="card2">
                            <div class="card-bg"></div>
                            <div class="card-texture"></div>
                            <div class="card-glow"></div>
                            <div class="top-bar">
                                <img src="@/assets/white_logo.svg" alt="Succour Logo" style="
            height:28px;
            object-fit:contain;
            display:block;
        " />
                                <div class="care-id-pill">CARE ID</div>
                            </div>
                            <div class="tier-stripe">
                                <div class="tier-text">{{ cg.verification.tier }} Tier</div>
                            </div>
                            <div class="body">
                                <div class="top-section">
                                    <div class="photo-box">
                                        <img v-if="cg.profile_photo" :src="cg.profile_photo" style="
            width:100%;
            height:100%;
            object-fit:cover;
            display:block;
        " />
                                    </div>
                                    <div class="name-block">
                                        <div class="first-name">{{ cg.fn }}</div>
                                        <div class="last-name">{{ cg.ln }}</div>
                                        <div class="cw-id">{{ cg.care_id }}</div>
                                    </div>
                                </div>
                                <hr class="sep">
                                <div class="score-box">
                                    <div class="score-row"><span class="score-num">{{
                                            cg.verification.trust_score}}</span><span class="score-denom">/ 835</span>
                                    </div>
                                    <hr class="score-divider">
                                    <div class="score-label">Trust Score Index</div>
                                </div>
                                <div class="tags">
                                    <div v-for="category in cg.category_links" :key="category.id" class="tag">
                                        {{ category.category_name }}
                                    </div>
                                </div>
                                <div class="footer-row">
                                    <div class="dates-col">
                                        <div>
                                            <div class="field-label">Issue Date</div>
                                            <div class="field-value">{{ formatDate(cg.issued_at) }}</div>
                                        </div>
                                        <div>
                                            <div class="field-label">Expiry Date</div>
                                            <div class="field-value">{{ formatDate(cg.expires_at) }}</div>
                                        </div>
                                        <div class="verify-link"><a :href="verifyLink" class="verify-link">{{ verifyLink
                                                }}</a></div>
                                    </div>
                                    <div :id="`qr-wrap-${qr2}`" class="qr-wrap">
                                        <canvas :ref="qr2"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="share-wrap">

                            <!-- WhatsApp -->
                            <button class="cid-share-btn copy" @click="shareAll('card2')">
                                Share
                            </button>

                            <!-- Copy -->
                            <button class="cid-share-btn copy" @click="copyLink">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <rect x="9" y="9" width="13" height="13" rx="2" />
                                    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                                </svg>

                                {{ copied ? '✓ Copied!' : 'Copy Link' }}
                            </button>

                        </div>
                    </div>

                    <!-- BRONZE -->
                    <div v-if="cg && cg.verification?.tier === 'bronze'">
                        <div class="card bronze" ref="card3">
                            <div class="card-bg"></div>
                            <div class="card-texture"></div>
                            <div class="card-glow"></div>
                            <div class="top-bar">
                                <img src="@/assets/white_logo.svg" alt="Succour Logo" style="
            height:28px;
            object-fit:contain;
            display:block;
        " />
                                <div class="care-id-pill">CARE ID</div>
                            </div>
                            <div class="tier-stripe">
                                <div class="tier-text">{{ cg.verification.tier }} Tier</div>
                            </div>
                            <div class="body">
                                <div class="top-section">
                                    <div class="photo-box">
                                        <img v-if="cg.profile_photo" :src="cg.profile_photo" style="
            width:100%;
            height:100%;
            object-fit:cover;
            display:block;
        " />
                                    </div>
                                    <div class="name-block">
                                        <div class="first-name">{{ cg.fn }}</div>
                                        <div class="last-name">{{ cg.ln }}</div>
                                        <div class="cw-id">{{ cg.care_id }}</div>
                                    </div>
                                </div>
                                <hr class="sep">
                                <div class="score-box">
                                    <div class="score-row"><span class="score-num">{{ cg.verification.trust_score
                                            }}</span><span class="score-denom">/ 835</span></div>
                                    <hr class="score-divider">
                                    <div class="score-label">Trust Score Index</div>
                                </div>
                                <div class="tags">
                                    <div v-for="category in cg.category_links" :key="category.id" class="tag">
                                        {{ category.category_name }}
                                    </div>
                                </div>
                                <div class="footer-row">
                                    <div class="dates-col">
                                        <div>
                                            <div class="field-label">Issue Date</div>
                                            <div class="field-value">{{ formatDate(cg.issued_at) }}</div>
                                        </div>
                                        <div>
                                            <div class="field-label">Expiry Date</div>
                                            <div class="field-value">{{ formatDate(cg.expires_at) }}</div>
                                        </div>
                                        <div class="verify-link"><a :href="verifyLink" class="verify-link">{{ verifyLink
                                                }}</a></div>

                                    </div>
                                    <div :id="`qr-wrap-${qr3}`" class="qr-wrap">
                                        <canvas :ref="qr3"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="share-wrap">

                            <!-- WhatsApp -->
                            <button class="cid-share-btn copy" @click="shareAll('card3')">
                                Share
                            </button>

                            <!-- Copy -->
                            <button class="cid-share-btn copy" @click="copyLink">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <rect x="9" y="9" width="13" height="13" rx="2" />
                                    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                                </svg>

                                {{ copied ? '✓ Copied!' : 'Copy Link' }}
                            </button>

                        </div>
                    </div>

                </div>


                <!-- <div v-else style="display:flex;gap:28px;justify-content:center;flex-wrap:wrap;align-items:flex-start;">
                    <p>Care ID not issued for this particular caregiver</p>
                </div> -->
            </div>
        </div>
    </AdminLayout>
</template>

<script lang="js">
import AdminLayout from '../../Layouts/AdminLayout.vue';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Request from "@/utils/apiclient.js";
import { toPng } from 'html-to-image';
import ToastManagerVue from "@/components/ToastAlert/ToastManager.vue";


export default {
    components: {
        AdminLayout,
        LoadingSpinner,
        ToastManagerVue,
    },
    data() {
        return {
            isLoading: false,

            copied: false,
            // unique random id per component instance
            qr1: Math.random().toString(36).substring(2, 10),
            qr2: Math.random().toString(36).substring(2, 10),
            qr3: Math.random().toString(36).substring(2, 10),

            cg: {

                id: null,
                care_id: null,
                care_id_issued: false,
                issued_at: "",
                expires_at: "",
                status: 'pending',

                profile_photo: null,

                fn: '',
                ln: '',

                dob: null,
                gender: '',

                phone: '',
                whatsapp: '',
                email: '',

                state: '',

                exp_type: '',
                exp_years: '',

                arrangement: '',
                availability: '',

                education: '',
                english: '',

                cats: [],

                // -----------------------------
                // IDENTITY
                // -----------------------------
                bvn: '',
                nin: '',

                bvn_verified: null,
                nin_verified: null,

                // -----------------------------
                // GUARANTOR
                // -----------------------------
                gname: '',
                gphone: '',
                grel: '',
                gocc: '',
                gaddress: '',
                gstatus: 'pending',

                // -----------------------------
                // DOCUMENTS
                // -----------------------------
                documents: {

                    id: {
                        url: null,
                        status: 'pending'
                    },

                    certificate: {
                        url: null,
                        status: 'pending'
                    },

                    guarantor: {
                        url: null,
                        status: 'pending'
                    },
                    employment: {
                        url: null,
                        status: 'pending'
                    },

                },

                // -----------------------------
                // EMPLOYMENT
                // -----------------------------
                employment: [],

                employment_verified_count: 0,

                // -----------------------------
                // BACKGROUND CHECK
                // -----------------------------
                background: {

                    provider: null,

                    status: 'pending',

                    criminal_record: false,

                    notes: ''
                },

                // -----------------------------
                // REPUTATION
                // -----------------------------
                reputation: {


                },

                // -----------------------------
                // MALPRACTICE
                // -----------------------------
                malpractice: {

                    count: 0,

                    penalty_total: 0,

                    do_not_employ: false
                },

                // -----------------------------
                // VERIFICATION
                // -----------------------------


                verification: {
                    raw_score: 0,
                    trust_score: 0,
                    tier: "dne",
                    do_not_employ: false,
                    scores: {
                        bvn: 0,
                        nin: 0,
                        government_id: 0,
                        criminal_clearance: 0,
                        guarantor: 0,
                        education: 0,
                        certificate_score: 0,
                        employment_score: 0,
                        care_categories: 0,
                        reputation_score: 0,
                        malpractice_penalty: 0,
                        bronze_cap_reason: "",
                        silver_cap_reason: "",
                        gold_gate_failed: false
                    }
                }


            },
        }
    },
    computed: {
        initials() {
            return (this.cg?.fn?.[0] || '?') + (this.cg?.ln?.[0] || '?');
        },
        verifyLink() {
            return `https://succour.care/verify/${this.cg.care_id}`
        }
    },
    async mounted() {
        await this.fetchCargiverDetails();
        this.$nextTick(() => {

            this.generateQRCode(this.qr1, 75)
            this.generateQRCode(this.qr2, 75)
            this.generateQRCode(this.qr3, 75)

        });

    },
    methods: {
        formatDate(dateString) {
        return new Date(dateString).toLocaleDateString('en-US', {
            month: 'short',
            year: 'numeric'
        });
    },
        showToast(msg, statusValue) {
            this.toastManager?.addToast(msg, statusValue);
        },

       async captureCard(refName) {
    try {
        const el = this.$refs[refName];

        return await toPng(el, {
            pixelRatio: 3,
            cacheBust: true,
            backgroundColor: '#000000'
        });

    } catch (err) {
        console.error(err);
        return null;
    }
},
        async shareAll(refName) {

            try {

                this.isLoading = true;

                console.log("Sharing ref:", refName);

                // Capture DOM → image
                const imageBase64 = await this.captureCard(refName);

                if (!imageBase64) {

                    alert("Failed to capture card image.");

                    this.isLoading = false;

                    return;
                }

                const payload = {

                    image: imageBase64,

                    name: `${this.cg.fn} ${this.cg.ln}`,

                    care_id: this.cg.care_id,

                    caregiver_id: this.cg.id,

                    email: this.cg.email,

                    phone: this.cg.whatsapp || this.cg.phone
                };

                const request = new Request(
                    "/share/caregiver-card/"
                );

                await request.post(

                    payload,

                    async (res, error) => {

                        if (error) {

                            console.log(error);

                            const errorMsg =
                                error.message ||
                                error.error ||
                                "Failed to share caregiver card.";

                            this.showToast(errorMsg, "error");

                            this.isLoading = false;

                            return;
                        }

                        console.log("Shared successfully:", res);

                        this.showToast(
                            res.message || "Card shared successfully.",
                            "success"
                        );

                        this.isLoading = false;
                    }
                );

            } catch (error) {

                console.log(error);

                this.showToast(
                    error.message || "An unexpected error occurred.",
                    "error"
                );

                this.isLoading = false;
            }
        },

        async generateQRCode(refKey, size = 80) {
            try {
                const canvas = this.$refs[refKey]
                if (!canvas) return

                const qrText = this.verifyLink
                if (!qrText) return

                const url = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(qrText)}`

                const response = await fetch(url)
                const blob = await response.blob()

                const img = new Image()
                const objectUrl = URL.createObjectURL(blob)

                img.onload = () => {
                    const ctx = canvas.getContext('2d')

                    const dpr = window.devicePixelRatio || 1

                    // ✅ set size BEFORE drawing
                    canvas.width = size * dpr
                    canvas.height = size * dpr

                    canvas.style.width = size + "px"
                    canvas.style.height = size + "px"

                    ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
                    ctx.clearRect(0, 0, size, size)

                    ctx.drawImage(img, 0, 0, size, size)

                    URL.revokeObjectURL(objectUrl)
                }

                img.src = objectUrl

            } catch (error) {
                console.error('QR generation failed:', error)
            }
        },

        shareWhatsApp() {
            const message = encodeURIComponent(
                `Hi, please find my Succour Care ID below.

Name: ${this.cg.fn} ${this.cg.ln}
Care ID: ${this.cg.care_id}

Verify here:
${this.verifyLink}`
            )

            window.open(`https://wa.me/?text=${message}`, '_blank')
        },

        async copyLink() {
            try {
                await navigator.clipboard.writeText(this.verifyLink)

                this.copied = true

                setTimeout(() => {
                    this.copied = false
                }, 2000)

            } catch (error) {
                console.error('Failed to copy:', error)
            }
        },
        async fetchCargiverDetails() {
            try {

                this.isLoading = true;

                const request = new Request(
                    `/verification-center/${this.$route.params.id}/`
                );

                await request.get((res, error) => {

                    if (error) {
                        console.log("FETCH ERROR", error);
                        return;
                    }

                    console.log("ADMIN DATA", res);

                    if (res) {
                        this.cg = res;
                    }


                });

            } catch (err) {

                console.log("FETCH FAILED", err);

            } finally {

                this.isLoading = false;
            }
        },
    }
}

</script>

<style>
:root {
    --green: #17865F;
    --dkgreen: #0D5C40;
    --mdgreen: #2A9D74;
    --ltgreen: #E8F4EF;
    --bg: #D6EDE2;
    --card: #EEF7F2;
    --pink: #F59CAB;
    --amber: #FF9700;
    --white: #FFFFFF;
    --text: #1A1A1A;
    --muted: #5A7A69;
    --border: #C0DDD0;
    --red: #E74C3C;
    --red-lt: #FEE2E2;
    --orange: #F97316;
    --blue: #2563EB;
    --blue-lt: #EFF6FF;
}
</style>
<style lang="css" scoped>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body {
    font-family: 'DM Sans', sans-serif;
    background: var(--bg);
    color: var(--text);
    min-height: 100vh;
}

/* ── SYSTEM NAV ── */
.sys-nav {
    background: var(--dkgreen);
    display: flex;
    align-items: stretch;
    border-bottom: 2px solid rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 200;
    overflow-x: auto;
}

.sys-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 20px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
}

.sys-logo-mark {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    background: var(--pink);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Playfair Display', serif;
    font-size: 13px;
    color: white;
    font-weight: 700;
}

.sys-logo-text {
    font-size: 9px;
    letter-spacing: 3px;
    color: rgba(255, 255, 255, 0.65);
    font-weight: 600;
}

.sys-logo-tm {
    font-size: 6px;
    color: rgba(255, 255, 255, 0.35);
    vertical-align: super;
}

.sys-steps {
    display: flex;
    flex: 1;
    min-width: 0;
}

.sys-step {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 16px;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    transition: 0.2s;
    position: relative;
    flex-shrink: 0;
}

.sys-step:hover {
    background: rgba(255, 255, 255, 0.05);
}

.sys-step.active {
    border-bottom-color: var(--pink);
}

.sys-step.active .step-num {
    background: var(--pink);
    color: white;
}

.sys-step.active .step-label {
    color: white;
}

.sys-step.done .step-num {
    background: rgba(39, 174, 96, 0.3);
    color: #7FD4A6;
}

.sys-step.done .step-label {
    color: rgba(255, 255, 255, 0.6);
}

.step-num {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.4);
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: 0.2s;
}

.step-label {
    font-size: 11px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.4);
    transition: 0.2s;
    white-space: nowrap;
}

.step-arrow {
    color: rgba(255, 255, 255, 0.15);
    font-size: 14px;
    flex-shrink: 0;
}

.sys-badge {
    margin: auto 16px auto auto;
    font-size: 9px;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.3);
    text-transform: uppercase;
    white-space: nowrap;
    flex-shrink: 0;
}

/* ── VIEWS ── */
.view {
    display: block;
}

.view.active {
    display: block;
}

/* ── SHARED ── */
.page-wrap {
    max-width: 100%;
    margin: 0 auto;
    /* padding: 36px 24px 80px; */
}

.ph {
    margin-bottom: 14px;
}

.ptitle {
    font-size: 18px;
    font-weight: 600;
    color: #1A2E22;
}

.ptitle span {
    color: #17865F;
}

.page-hero {
    background: var(--dkgreen);
    padding: 36px 40px 44px;
    text-align: center;
}

.hero-tag {
    display: inline-block;
    font-size: 9px;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: var(--pink);
    border: 1px solid rgba(245, 156, 171, 0.3);
    border-radius: 20px;
    padding: 4px 14px;
    margin-bottom: 12px;
}

.hero-title {
    font-family: 'Playfair Display', serif;
    font-size: 30px;
    color: green;
    font-weight: 700;
    margin-bottom: 8px;
    line-height: 1.25;
}

.title-center {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.hero-title em {
    color: var(--pink);
    font-style: italic;
}

.hero-sub {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
    max-width: 480px;
    margin: 0 auto;
    line-height: 1.6;
}

/* ── PROGRESS BAR ── */
.progress-bar {
    display: flex;
    gap: 0;
    margin-bottom: 28px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid var(--border);
}

.pb-step {
    flex: 1;
    padding: 10px 14px;
    background: var(--card);
    border-right: 1px solid var(--border);
    display: flex;
    align-items: center;
    gap: 8px;
    transition: 0.3s;
}

.pb-step:last-child {
    border-right: none;
}

.pb-step.active {
    background: var(--green);
}

.pb-step.done {
    background: var(--dkgreen);
}

.pb-num {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.5);
    font-size: 9px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.pb-step.active .pb-num,
.pb-step.done .pb-num {
    background: rgba(255, 255, 255, 0.2);
    color: white;
}

.pb-lbl {
    font-size: 10px;
    color: var(--muted);
}

.pb-step.active .pb-lbl,
.pb-step.done .pb-lbl {
    color: white;
}

/* ── SECTION CARDS ── */
.section-card {
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 14px;
    padding: 24px 26px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-title {
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.section-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--border);
}

.section-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: var(--green);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    flex-shrink: 0;
}

/* ── FORM FIELDS ── */
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-bottom: 14px;
}

.form-grid-3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 14px;
    margin-bottom: 14px;
}

.form-grid-1 {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
    margin-bottom: 14px;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.field label {
    font-size: 10px;
    font-weight: 500;
    color: var(--muted);
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.field label .req {
    color: var(--red);
    margin-left: 2px;
}

.field input,
.field select,
.field textarea {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    background: white;
    border: 1px solid var(--border);
    border-radius: 9px;
    padding: 10px 13px;
    color: var(--text);
    outline: none;
    transition: 0.2s;
}

.field input:focus,
.field select:focus,
.field textarea:focus {
    border-color: var(--green);
    box-shadow: 0 0 0 3px rgba(23, 134, 95, 0.1);
}

.field input.invalid {
    border-color: var(--red);
    background: #FFF5F5;
}

.field textarea {
    resize: vertical;
    min-height: 80px;
}

.field select option {
    background: white;
}

.field-hint {
    font-size: 10px;
    color: var(--muted);
    margin-top: 3px;
}

/* ── PHOTO UPLOAD ── */
.photo-upload {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 14px;
}

.photo-preview {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: var(--ltgreen);
    border: 2px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    flex-shrink: 0;
    overflow: hidden;
    cursor: pointer;
    transition: 0.2s;
}

.photo-preview:hover {
    border-color: var(--green);
}

.photo-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.photo-upload-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid var(--border);
    background: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: var(--dkgreen);
    cursor: pointer;
    transition: 0.2s;
}

.photo-upload-btn:hover {
    border-color: var(--green);
    background: var(--ltgreen);
}

.photo-upload-hint {
    font-size: 10px;
    color: var(--muted);
    margin-top: 5px;
}

.photo-required-note {
    font-size: 10px;
    color: var(--red);
    margin-top: 5px;
    display: none;
}

/* ── DOCUMENT UPLOAD ── */
.doc-upload-zone {
    border: 2px dashed var(--border);
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: 0.2s;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.doc-upload-zone:hover,
.doc-upload-zone.drag {
    border-color: var(--green);
    background: var(--ltgreen);
}

.doc-icon {
    font-size: 24px;
}

.doc-upload-label {
    font-size: 12px;
    font-weight: 500;
    color: var(--dkgreen);
}

.doc-upload-sub {
    font-size: 10px;
    color: var(--muted);
}

.doc-upload-zone input[type=file] {
    display: none;
}

.doc-uploaded {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: var(--ltgreen);
    border: 1px solid var(--border);
    border-radius: 8px;
    margin-top: 8px;
}

.doc-uploaded-name {
    font-size: 12px;
    color: var(--dkgreen);
    font-weight: 500;
    flex: 1;
}

.doc-remove {
    font-size: 10px;
    color: var(--red);
    cursor: pointer;
    font-weight: 600;
}

/* camera / upload dual option */
.dual-upload {
    display: flex;
    gap: 10px;
    margin-bottom: 8px;
}

.dual-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 14px 10px;
    border-radius: 10px;
    border: 1.5px dashed var(--border);
    background: white;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    font-weight: 500;
    color: var(--dkgreen);
    transition: 0.2s;
}

.dual-btn:hover {
    border-color: var(--green);
    background: var(--ltgreen);
}

.dual-btn span {
    font-size: 22px;
}

/* ── REFERENCE ROWS ── */
.ref-row {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 10px;
    align-items: end;
    margin-bottom: 10px;
    background: white;
    padding: 12px;
    border-radius: 9px;
    border: 1px solid var(--border);
}

.ref-row-num {
    font-size: 10px;
    font-weight: 600;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 4px;
}

.ref-remove-btn {
    width: 30px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid var(--border);
    background: white;
    color: var(--red);
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    align-self: flex-end;
}

.ref-remove-btn:hover {
    background: var(--red-lt);
}

.add-ref-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px dashed var(--green);
    background: var(--ltgreen);
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: var(--dkgreen);
    cursor: pointer;
    transition: 0.2s;
    margin-top: 4px;
}

.add-ref-btn:hover {
    background: var(--card);
}

/* ── EMPLOYMENT HISTORY ROWS ── */
.emp-history-row {
    background: white;
    padding: 14px 16px;
    border-radius: 9px;
    border: 1px solid var(--border);
    margin-bottom: 10px;
}

.emp-row-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.emp-row-num {
    font-size: 10px;
    font-weight: 600;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: 1px;
}

.emp-row-remove {
    font-size: 11px;
    color: var(--red);
    cursor: pointer;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 5px;
    border: 1px solid var(--red);
    background: transparent;
    font-family: 'DM Sans', sans-serif;
    transition: 0.2s;
}

.emp-row-remove:hover {
    background: var(--red-lt);
}

.add-emp-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px dashed var(--green);
    background: var(--ltgreen);
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: var(--dkgreen);
    cursor: pointer;
    transition: 0.2s;
    margin-top: 4px;
}

.add-emp-btn:hover {
    background: var(--card);
}

/* ── CATEGORY TOGGLES ── */
.cat-grid {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.cat-toggle {
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid var(--border);
    background: white;
    font-size: 12px;
    font-weight: 500;
    color: var(--muted);
    cursor: pointer;
    transition: 0.2s;
    user-select: none;
}

.cat-toggle.selected {
    background: var(--green);
    border-color: var(--green);
    color: white;
}

/* ── CONSENT BOX ── */
.consent-box {
    background: white;
    border: 1.5px solid var(--border);
    border-radius: 10px;
    padding: 16px 18px;
    margin-bottom: 16px;
}

.consent-inner {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}

.consent-inner input[type=checkbox] {
    width: 18px;
    height: 18px;
    margin-top: 2px;
    flex-shrink: 0;
    accent-color: var(--green);
    cursor: pointer;
}

.consent-text {
    font-size: 12px;
    color: var(--text);
    line-height: 1.6;
}

.consent-text strong {
    color: var(--dkgreen);
}

/* ── SUBMIT BTN ── */
.submit-btn {
    width: 100%;
    padding: 15px;
    border-radius: 10px;
    border: none;
    background: var(--green);
    color: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: 0.2s;
    margin-top: 8px;
}

.submit-btn:hover {
    background: var(--mdgreen);
}

.submit-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.doc-uploaded-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px;
    margin-top: 14px;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
    transition: 0.25s ease;
}

.doc-remove-btn {
    border: none;
    background: #ffe9e9;
    color: #d93025;
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s ease;
}

/* ── SUCCESS STATE ── */
.success-state {
    text-align: center;
    padding: 48px 24px;
    display: none;
}

.success-state.show {
    display: block;
    animation: fadeUp 0.4s ease;
}

.success-icon {
    font-size: 48px;
    margin-bottom: 16px;
}

.success-title {
    font-family: 'Playfair Display', serif;
    font-size: 24px;
    color: var(--dkgreen);
    margin-bottom: 8px;
}

.success-sub {
    font-size: 13px;
    color: var(--muted);
    max-width: 400px;
    margin: 0 auto 24px;
    line-height: 1.6;
}

.success-ref {
    font-family: 'DM Mono', monospace;
    font-size: 13px;
    color: var(--green);
    background: var(--ltgreen);
    padding: 8px 20px;
    border-radius: 8px;
    border: 1px solid var(--border);
    display: inline-block;
}

/* ── OPS QUEUE ── */
.ops-banner {
    background: #FFFBEB;
    border: 1px solid rgba(255, 151, 0, 0.3);
    border-radius: 10px;
    padding: 12px 18px;
    margin-bottom: 20px;
    font-size: 11px;
    color: #92400E;
    display: flex;
    align-items: center;
    gap: 8px;
}

.queue-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.queue-table th {
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    padding: 10px 12px;
    text-align: left;
    border-bottom: 2px solid var(--border);
}

.queue-table td {
    font-size: 12px;
    color: var(--text);
    padding: 12px 12px;
    border-bottom: 1px solid var(--border);
    vertical-align: middle;
}

.queue-table tr:hover td {
    background: var(--ltgreen);
}

.status-pill {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 3px 10px;
    border-radius: 20px;
}

.status-pill.pending {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.25);
}

.status-pill.in-progress {
    background: rgba(37, 99, 235, 0.08);
    color: #1D4ED8;
    border: 1px solid rgba(37, 99, 235, 0.2);
}

.status-pill.complete {
    background: #E8F7F0;
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.review-btn {
    font-size: 11px;
    font-weight: 600;
    padding: 5px 14px;
    border-radius: 7px;
    border: 1px solid var(--border);
    background: white;
    color: var(--dkgreen);
    cursor: pointer;
    transition: 0.2s;
}

.review-btn:hover {
    background: var(--ltgreen);
    border-color: var(--green);
}

/* ── OPS VERIFICATION PANEL ── */
.ops-profile {
    background: white;
    border: 1px solid var(--border);
    border-radius: 14px;
    padding: 20px 22px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
}

.ops-av {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--green), #2CC89A);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Playfair Display', serif;
    font-size: 20px;
    color: white;
    font-weight: 700;
    flex-shrink: 0;
    overflow: hidden;
}

.ops-av img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.ops-profile-name {
    font-family: 'Playfair Display', serif;
    font-size: 17px;
    color: var(--dkgreen);
}

.ops-profile-meta {
    font-size: 11px;
    color: var(--muted);
    margin-top: 3px;
}

.ops-profile-ref {
    font-family: 'DM Mono', monospace;
    font-size: 10px;
    color: var(--muted);
    margin-top: 2px;
}

/* API badge */
.api-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 3px 9px;
    border-radius: 20px;
    margin-left: 8px;
}

.api-badge.auto {
    background: rgba(37, 99, 235, 0.08);
    color: #1D4ED8;
    border: 1px solid rgba(37, 99, 235, 0.2);
}

.api-badge.manual {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.3);
}

/* signals */
.sig-block {
    background: white;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 18px 20px;
    margin-bottom: 14px;
}

.sig-block-title {
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.sig-block-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--border);
}

.sig-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 0;
    border-bottom: 1px solid var(--border);
}

.sig-row:last-child {
    border: none;
    padding-bottom: 0;
}

.sig-left {
    flex: 1;
}

.sig-name {
    font-size: 12px;
    font-weight: 500;
    color: var(--text);
}

.sig-sub {
    font-size: 10px;
    color: var(--muted);
    margin-top: 2px;
}

.sig-doc {
    font-size: 10px;
    color: var(--green);
    text-decoration: underline;
    cursor: pointer;
    margin-top: 2px;
}

.sig-select {
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 7px;
    padding: 6px 10px;
    color: var(--text);
    outline: none;
    min-width: 200px;
    cursor: pointer;
}

.sig-select:focus {
    border-color: var(--green);
}

.sig-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
}

/* reputation counters */
.rep-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    margin-top: 8px;
}

.rep-counter {
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 10px 12px;
    text-align: center;
}

.rep-counter-label {
    font-size: 9px;
    font-weight: 600;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 8px;
}

.rep-ctrl {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.rev-btn {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid var(--border);
    background: white;
    color: var(--green);
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.15s;
}

.rev-btn:hover {
    background: var(--ltgreen);
    border-color: var(--green);
}

.rev-count {
    font-size: 16px;
    font-weight: 700;
    color: var(--dkgreen);
    min-width: 22px;
    text-align: center;
}

/* NPF upload */
.npf-upload {
    margin-top: 10px;
    display: block;
}

.npf-upload.show {
    display: block;
}

/* compute */
.compute-btn {
    width: 100%;
    padding: 14px;
    border-radius: 10px;
    border: none;
    background: var(--green);
    color: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: 0.2s;
    margin-top: 4px;
}

.compute-btn:hover {
    background: var(--mdgreen);
}

/* DNE banner */
.dne-banner {
    background: #FEE2E2;
    border: 2px solid var(--red);
    border-radius: 12px;
    padding: 20px 22px;
    margin-top: 14px;
    /* display: none; */
    animation: fadeUp 0.35s ease;
}

.dne-banner.show {
    display: block;
}

.dne-title {
    font-family: 'Playfair Display', serif;
    font-size: 18px;
    color: var(--red);
    font-weight: 700;
    margin-bottom: 6px;
}

.dne-sub {
    font-size: 13px;
    color: #7F1D1D;
    line-height: 1.6;
}

/* score result */
.score-result {
    /* display: none; */
    background: var(--dkgreen);
    border-radius: 14px;
    padding: 24px 26px;
    margin-top: 14px;
}

.score-result.show {
    display: block;
    animation: fadeUp 0.35s ease;
}

.sr-top {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.share-wrap {
    display: flex;
    gap: 8px;
    width: 300px;
    margin-top: 50px;
}

.cid-share-btn {
    border: none;
    padding: 10px 14px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 7px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: 0.2s ease;
}

.cid-share-btn:hover {
    transform: translateY(-1px);
}

.cid-share-btn.wa {
    background: #25D366;
    color: white;
}

.cid-share-btn.copy {
    background: #f1f3f5;
    color: #222;
}

.sr-num {
    font-family: 'Playfair Display', serif;
    font-size: 56px;
    color: white;
    line-height: 1;
    font-weight: 700;
}

.sr-denom {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.35);
    margin-top: 4px;
}

.sr-tier {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 5px 16px;
    border-radius: 20px;
    display: inline-block;
    margin-bottom: 6px;
}

.sr-tier.unverified {
    background: rgba(231, 76, 60, 0.2);
    color: #FCA5A5;
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.sr-tier.bronze {
    background: rgba(255, 151, 0, 0.2);
    color: var(--amber);
    border: 1px solid rgba(255, 151, 0, 0.3);
}

.sr-tier.silver {
    background: rgba(200, 230, 215, 0.2);
    color: #A7D4BE;
    border: 1px solid rgba(200, 230, 215, 0.3);
}

.sr-tier.gold {
    background: rgba(255, 215, 0, 0.15);
    color: #FFD700;
    border: 1px solid rgba(255, 215, 0, 0.25);
}

.sr-deploy {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.45);
}

.sr-checklist {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.sr-check {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 10px;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.05);
}

.sr-ck-icon {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    flex-shrink: 0;
}

.sr-ck-icon.ok {
    background: rgba(39, 174, 96, 0.25);
    color: #7FD4A6;
}

.sr-ck-icon.fail {
    background: rgba(231, 76, 60, 0.2);
    color: #FCA5A5;
}

.sr-ck-lbl {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
}

.issue-btn {
    width: 100%;
    padding: 13px;
    border-radius: 10px;
    border: none;
    background: var(--pink);
    color: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: 0.2s;
    margin-top: 12px;
}

.issue-btn:hover {
    background: #e08a99;
}

/* ── EMPLOYER VIEW (standard) ── */
.ev-card {
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    max-width: 480px;
    margin: 0 auto;
}

.ev-stripe {
    height: 5px;
    background: linear-gradient(90deg, var(--green), #2CC89A, var(--pink));
}

.ev-body {
    padding: 24px 26px;
}

.ev-hdr {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 18px;
    padding-bottom: 16px;
    border-bottom: 1px solid #EEF4F1;
}

.ev-photo {
    width: 52px;
    height: 52px;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--green), #2CC89A);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Playfair Display', serif;
    font-size: 20px;
    color: white;
    font-weight: 700;
    flex-shrink: 0;
    overflow: hidden;
}

.ev-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.ev-name {
    font-family: 'Playfair Display', serif;
    font-size: 17px;
    color: var(--text);
    font-weight: 700;
}

.ev-sc {
    font-family: 'DM Mono', monospace;
    font-size: 10px;
    color: var(--muted);
    margin-top: 3px;
}

.ev-tbadge {
    margin-left: auto;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 5px 14px;
    border-radius: 20px;
}

.ev-tbadge.gold {
    background: rgba(255, 215, 0, 0.1);
    color: #B8860B;
    border: 1px solid rgba(255, 215, 0, 0.25);
}

.ev-tbadge.silver {
    background: var(--ltgreen);
    color: var(--dkgreen);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.ev-tbadge.bronze {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.2);
}

.ev-score-block {
    display: flex;
    align-items: center;
    gap: 14px;
    background: var(--ltgreen);
    border-radius: 12px;
    padding: 14px 18px;
    margin-bottom: 18px;
    border: 1px solid rgba(23, 134, 95, 0.12);
}

.ev-score-num {
    font-family: 'Playfair Display', serif;
    font-size: 46px;
    color: var(--dkgreen);
    line-height: 1;
    font-weight: 700;
}

.ev-score-denom {
    font-size: 12px;
    color: var(--muted);
}

.ev-score-level {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 3px 12px;
    border-radius: 20px;
    margin-top: 4px;
}

.ev-score-level.gold {
    background: rgba(255, 215, 0, 0.1);
    color: #B8860B;
    border: 1px solid rgba(255, 215, 0, 0.2);
}

.ev-score-level.silver {
    background: rgba(23, 134, 95, 0.1);
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.ev-score-level.bronze {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.15);
}

.ev-cats-lbl {
    font-size: 8px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 7px;
}

.ev-cats {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-bottom: 16px;
}

.ev-cat {
    font-size: 10px;
    color: var(--dkgreen);
    font-weight: 500;
    background: var(--ltgreen);
    border: 1px solid var(--border);
    padding: 4px 10px;
    border-radius: 20px;
}

.ev-br-lbl {
    font-size: 8px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 10px;
}

.ev-row-item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
}

.ev-rl {
    font-size: 11px;
    color: var(--text);
    width: 100px;
    flex-shrink: 0;
}

.ev-bar-track {
    flex: 1;
    height: 6px;
    background: #EEF4F1;
    border-radius: 6px;
    overflow: hidden;
}

.ev-bar-fill {
    height: 100%;
    border-radius: 6px;
}

.ev-bar-fill.excellent {
    background: var(--green);
    width: 92%;
}

.ev-bar-fill.good {
    background: var(--amber);
    width: 70%;
}

.ev-bar-fill.average {
    background: #F0A05A;
    width: 48%;
}

.ev-bar-fill.poor {
    background: var(--red);
    width: 24%;
}

.ev-rval {
    font-size: 10px;
    font-weight: 600;
    width: 58px;
    text-align: right;
}

.ev-rval.excellent {
    color: var(--green);
}

.ev-rval.good {
    color: #B36800;
}

.ev-rval.average {
    color: #E07020;
}

.ev-rval.poor {
    color: var(--red);
}

.ev-status {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 11px 14px;
    background: #E8F7F0;
    border-radius: 10px;
    border: 1px solid rgba(23, 134, 95, 0.2);
    margin: 14px 0;
}

.ev-sdot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--green);
    flex-shrink: 0;
    animation: pulse 2s infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1
    }

    50% {
        opacity: 0.5
    }
}

.ev-stext {
    font-size: 12px;
    color: var(--dkgreen);
    font-weight: 600;
}

.ev-sdate {
    font-size: 10px;
    color: var(--muted);
    margin-left: auto;
}

.ev-qr-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 14px;
    border-top: 1px solid #EEF4F1;
}

.ev-qr-box {
    width: 60px;
    height: 60px;
    background: var(--ltgreen);
    border-radius: 8px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ev-share-btns {
    display: flex;
    gap: 8px;
}

.ev-share-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    font-weight: 600;
    transition: 0.2s;
}

.ev-share-btn.wa {
    background: #25D366;
    color: white;
}

.ev-share-btn.wa:hover {
    background: #1DA851;
}

.ev-share-btn.copy {
    background: var(--ltgreen);
    color: var(--dkgreen);
    border: 1px solid var(--border);
}

.ev-share-btn.copy:hover {
    background: #D0EBE0;
}

.ev-footer-lnk {
    font-size: 9px;
    color: var(--muted);
    text-align: center;
    margin-top: 12px;
}

.ev-footer-lnk a {
    color: var(--green);
    font-weight: 600;
    text-decoration: none;
}

.cid-qr-box {
    width: 48px;
    height: 48px;
    background: white;
    border-radius: 7px;
    padding: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.cid-qr-box-alt {
    width: 46px;
    height: 46px;
    background: var(--ltgreen);
    border-radius: 7px;
    padding: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

/* ── DETAILED EMPLOYER VIEW (payment gated) ── */
.pay-gate {
    background: var(--dkgreen);
    border-radius: 16px;
    overflow: hidden;
    max-width: 560px;
    margin: 0 auto 20px;
}

.pay-gate-body {
    padding: 32px;
}

.pay-gate-icon {
    font-size: 36px;
    margin-bottom: 12px;
}

.pay-gate-title {
    font-family: 'Playfair Display', serif;
    font-size: 22px;
    color: white;
    margin-bottom: 8px;
}

.pay-gate-sub {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
    line-height: 1.6;
    margin-bottom: 24px;
}

.pay-features {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
}

.pay-feature {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
}

.pay-feature-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--pink);
    flex-shrink: 0;
}

.pay-price {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 20px;
}

.pay-amount {
    font-family: 'Playfair Display', serif;
    font-size: 32px;
    color: white;
    font-weight: 700;
}

.pay-period {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.45);
}

.pay-btn {
    width: 100%;
    padding: 14px;
    border-radius: 10px;
    border: none;
    background: var(--pink);
    color: white;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: 0.2s;
}

.pay-btn:hover {
    background: #e08a99;
}

.pay-note {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.3);
    text-align: center;
    margin-top: 10px;
}

/* detailed report */
.det-report {
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    max-width: 600px;
    margin: 0 auto;
    display: none;
    animation: fadeUp 0.4s ease;
}

.det-report.show {
    display: block;
}

.det-header {
    background: var(--dkgreen);
    padding: 24px 26px;
    display: flex;
    align-items: center;
    gap: 14px;
}

.det-photo {
    width: 56px;
    height: 56px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Playfair Display', serif;
    font-size: 22px;
    color: white;
    flex-shrink: 0;
    overflow: hidden;
}

.det-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.det-title {
    font-family: 'Playfair Display', serif;
    font-size: 18px;
    color: white;
    font-weight: 700;
}

.det-sub {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 3px;
}

.det-badge {
    margin-left: auto;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 5px 14px;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
}

.det-body {
    padding: 24px 26px;
}

.det-section {
    margin-bottom: 22px;
}

.det-section-title {
    font-size: 8px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.det-section-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--border);
}

.det-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 0;
    border-bottom: 1px solid var(--border);
    font-size: 12px;
}

.det-row:last-child {
    border: none;
}

.det-key {
    color: var(--muted);
}

.det-val {
    font-weight: 500;
    color: var(--text);
}

.det-status {
    font-size: 10px;
    font-weight: 700;
    padding: 3px 9px;
    border-radius: 20px;
}

.det-status.verified {
    background: #E8F7F0;
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.det-status.not-verified {
    background: #FFFBEB;
    color: #92400E;
    border: 1px solid rgba(255, 151, 0, 0.3);
}

.det-status.forged {
    background: var(--red-lt);
    color: var(--red);
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.det-status.clear {
    background: #E8F7F0;
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.det-status.record {
    background: var(--red-lt);
    color: var(--red);
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.det-status.positive {
    background: #E8F7F0;
    color: var(--green);
    border: 1px solid rgba(23, 134, 95, 0.2);
}

.det-status.negative {
    background: var(--red-lt);
    color: var(--red);
    border: 1px solid rgba(231, 76, 60, 0.3);
}

.det-warning {
    background: var(--red-lt);
    border: 1px solid rgba(231, 76, 60, 0.3);
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 11px;
    color: #7F1D1D;
    margin-top: 12px;
}

/* ── CARE ID ── */
.cid-cat {
    font-size: 8px;
    font-weight: 500;
    padding: 3px 8px;
    border-radius: 20px;
}

.cid-cat-dark {
    color: rgba(255, 255, 255, 0.55);
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
}

.cid-cat-light {
    color: var(--dkgreen);
    background: var(--ltgreen);
    border: 1px solid var(--border);
}

.cid-share-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 9px 10px;
    border-radius: 9px;
    border: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    font-weight: 600;
    transition: 0.18s;
}

.cid-share-btn.wa {
    background: #25D366;
    color: white;
}

.cid-share-btn.wa:hover {
    background: #1DA851;
}

.cid-share-btn.copy {
    background: white;
    color: var(--dkgreen);
    border: 1px solid var(--border);
}

.cid-share-btn.copy:hover {
    background: var(--ltgreen);
}

/* ── UTILITIES ── */
@keyframes fadeUp {
    from {
        opacity: 0;
        transform: translateY(8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.notice {
    padding: 14px 18px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 1.6;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.notice.info {
    background: rgba(37, 99, 235, 0.06);
    border: 1px solid rgba(37, 99, 235, 0.15);
    color: #1D4ED8;
}

.notice.warn {
    background: #FFFBEB;
    border: 1px solid rgba(255, 151, 0, 0.3);
    color: #92400E;
}

.notice.danger {
    background: var(--red-lt);
    border: 1px solid rgba(231, 76, 60, 0.3);
    color: #7F1D1D;
}
</style>

<style lang="css" scoped>

.scene {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding: 48px 24px;
    background: transparent;
    border-radius: 20px;
    flex-wrap: wrap;
}

.card-label {
    font-family: 'Inter', sans-serif;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #666;
    text-align: center;
    margin-bottom: 12px;
}

.card {
    width: 320px;
    height: 545px;
    border-radius: 22px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    font-family: 'Inter', sans-serif;
    color: #fff;
}

.card-bg {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(ellipse at 20% 0%, #006b46 0%, transparent 55%),
        radial-gradient(ellipse at 90% 100%, #004530 0%, transparent 50%),
        linear-gradient(160deg, #005a3c 0%, #003828 50%, #002a1e 100%);
}

.card-texture {
    position: absolute;
    inset: 0;
    background-image:
        repeating-linear-gradient(45deg, transparent, transparent 14px, rgba(255, 255, 255, 0.012) 14px, rgba(255, 255, 255, 0.012) 28px),
        repeating-linear-gradient(-45deg, transparent, transparent 14px, rgba(255, 255, 255, 0.008) 14px, rgba(255, 255, 255, 0.008) 28px);
}

.card-glow {
    position: absolute;
    inset: 0;
    border-radius: 19px;
    pointer-events: none;
    z-index: 10;
}

.gold {
    border: 3px solid #c9911a;
    box-shadow: 0 2px 0 rgba(255, 200, 80, 0.4), 0 30px 80px rgba(0, 0, 0, 0.7), 0 8px 20px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 210, 100, 0.15);
}

.gold .card-glow {
    box-shadow: inset 0 0 0 1px rgba(255, 190, 50, 0.12), inset 0 0 40px rgba(0, 0, 0, 0.3);
}

.gold .top-bar {
    border-bottom: 1px solid rgba(201, 145, 26, 0.4);
}

.gold .tier-stripe {
    background: linear-gradient(180deg, #ffcb47 0%, #e8a800 40%, #ffb81c 70%, #c98c00 100%);
}

.gold .tier-text {
    color: #1e3a00;
}

.gold .sep {
    background: linear-gradient(90deg, rgba(201, 145, 26, 0.6), rgba(201, 145, 26, 0.08));
}

.gold .score-box {
    border: 1px solid rgba(201, 145, 26, 0.2);
}

.gold .photo-box {
    border: 2px solid #c9911a;
}

.gold .qr-wrap {
    border: 2.5px solid #c9911a;
}

.gold .first-name,
.gold .last-name {
    color: #ffb81c;
}

.silver {
    border: 3px solid #9aafc4;
    box-shadow: 0 2px 0 rgba(180, 200, 230, 0.3), 0 30px 80px rgba(0, 0, 0, 0.7), 0 8px 20px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(200, 220, 240, 0.1);
}

.silver .card-glow {
    box-shadow: inset 0 0 0 1px rgba(154, 175, 196, 0.12), inset 0 0 40px rgba(0, 0, 0, 0.3);
}

.silver .top-bar {
    border-bottom: 1px solid rgba(154, 175, 196, 0.45);
}

.silver .tier-stripe {
    background: linear-gradient(180deg, #dce6f0 0%, #aabccc 35%, #c4d2de 65%, #8a9eae 100%);
}

.silver .tier-text {
    color: #1a2e3a;
}

.silver .sep {
    background: linear-gradient(90deg, rgba(154, 175, 196, 0.7), rgba(154, 175, 196, 0.08));
}

.silver .score-box {
    border: 1px solid rgba(154, 175, 196, 0.25);
}

.silver .photo-box {
    border: 2px solid #9aafc4;
}

.silver .qr-wrap {
    border: 2.5px solid #9aafc4;
}

.silver .first-name,
.silver .last-name {
    color: #c8dce8;
}

.bronze {
    border: 3px solid #b8864e;
    box-shadow: 0 2px 0 rgba(200, 150, 80, 0.3), 0 30px 80px rgba(0, 0, 0, 0.7), 0 8px 20px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(200, 150, 100, 0.1);
}

.bronze .card-glow {
    box-shadow: inset 0 0 0 1px rgba(184, 134, 78, 0.12), inset 0 0 40px rgba(0, 0, 0, 0.3);
}

.bronze .top-bar {
    border-bottom: 1px solid rgba(184, 134, 78, 0.45);
}

.bronze .tier-stripe {
    background: linear-gradient(180deg, #d4a46a 0%, #a06c38 35%, #c08448 65%, #7a5028 100%);
}

.bronze .tier-text {
    color: #1e0e04;
}

.bronze .sep {
    background: linear-gradient(90deg, rgba(184, 134, 78, 0.7), rgba(184, 134, 78, 0.08));
}

.bronze .score-box {
    border: 1px solid rgba(184, 134, 78, 0.25);
}

.bronze .photo-box {
    border: 2px solid #b8864e;
}

.bronze .qr-wrap {
    border: 2.5px solid #b8864e;
}

.bronze .first-name,
.bronze .last-name {
    color: #d4a468;
}

.top-bar {
    position: relative;
    z-index: 5;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px 0 14px;
    background: rgba(0, 0, 0, 0.22);
}

.logo-svg {
    height: 22px;
    width: auto;
}

.care-id-pill {
    border: 2px solid rgba(255, 255, 255, 0.75);
    border-radius: 24px;
    padding: 5px 18px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #fff;
    background: rgba(255, 255, 255, 0.05);
}

.tier-stripe {
    position: absolute;
    right: 0;
    top: 58px;
    bottom: 0;
    width: 42px;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.15), inset 1px 0 0 rgba(0, 0, 0, 0.1);
}

.tier-text {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transform: rotate(180deg);
    font-family: 'Calibri', 'Candara', 'Segoe UI', Georgia, sans-serif;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 3.5px;
    text-transform: uppercase;
    white-space: nowrap;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.25);
}

.body {
    position: absolute;
    top: 58px;
    left: 0;
    right: 42px;
    bottom: 0;
    padding: 0 16px 20px 16px;
    box-sizing: border-box;
    z-index: 4;
    display: flex;
    flex-direction: column;
}

.top-section {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    padding-top: 18px;
}

.photo-box {
    width: 108px;
    height: 126px;
    flex-shrink: 0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.photo-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
}

.name-block {
    flex: 1;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.first-name {
    font-size: 26px;
    font-weight: 800;
    line-height: 1.1;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.last-name {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.1;
    opacity: 0.9;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.cw-id {
    font-size: 10px;
    color: rgba(163, 203, 214, 0.85);
    letter-spacing: 0.8px;
    font-weight: 500;
    margin-top: 5px;
}

.sep {
    height: 1px;
    border: none;
    margin: 16px 0 0 0;
    flex-shrink: 0;
}

.score-box {
    background: rgba(0, 0, 0, 0.28);
    border-radius: 14px;
    padding: 14px 14px 10px;
    position: relative;
    margin-top: 13px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
    flex-shrink: 0;
}

.score-row {
    display: flex;
    align-items: baseline;
    gap: 5px;
}

.score-num {
    font-size: 60px;
    font-weight: 300;
    line-height: 1;
    color: #fff;
    letter-spacing: -2px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
}

.score-denom {
    font-size: 16px;
    font-weight: 300;
    color: rgba(163, 203, 214, 0.7);
}

.score-divider {
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    margin: 10px 0 7px;
}

.score-label {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: rgba(163, 203, 214, 0.65);
    text-align: center;
}

.tags {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
    margin-top: 14px;
    flex-shrink: 0;
}

.tag {
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 20px;
    padding: 3px 9px;
    font-size: 9.5px;
    font-weight: 500;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.85);

    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.footer-row {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.dates-col {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.field-label {
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: rgba(163, 203, 214, 0.65);
    line-height: 1;
}

.field-value {
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    margin-top: 2px;
    line-height: 1;
}

.verify-link {
    font-size: 7px;
    color: rgba(163, 203, 214, 0.45);
    margin-top: 7px;
    letter-spacing: 0.2px;
}

.verify-link a {
    text-decoration: none;
}

.qr-wrap svg {
    width: 100%;
    height: 100%;
    display: block;
}

.qr-wrap {
    width: 80px;
    height: 80px;
    background: #fff;
    border-radius: 11px;
    overflow: hidden;
}

.qr-wrap canvas {
    width: 100%;
    height: 100%;
    display: block;
}

.logo-svg-inline {
    height: 22px;
    width: auto;
}
</style>